import { useState, useCallback } from 'react';

export const useIFSCValidation = (provider = 'razorpay') => {
    const [loading, setLoading] = useState(false);
    const [bankDetails, setBankDetails] = useState(null);
    const [error, setError] = useState(null);

    const validateIFSC = useCallback(async (ifscCode, apiKey = null) => {
        if (!ifscCode || ifscCode.length !== 11) {
            setError('IFSC code must be 11 characters long');
            setBankDetails(null);
            return { isValid: false };
        }

        setLoading(true);
        setError(null);

        let result;
        try {
            switch (provider) {
                case 'razorpay':
                    result = await validateIFSCRazorpay(ifscCode);
                    break;
                // case 'bulkpe':
                //     result = await validateIFSCBulkpe(ifscCode, apiKey);
                //     break;
                // case 'apyhub':
                //     result = await validateIFSCApyHub(ifscCode, apiKey);
                //     break;
                default:
                    result = await validateIFSCRazorpay(ifscCode);
            }

            if (result.isValid) {
                setBankDetails(result.bankDetails);
                setError(null);
            } else {
                setBankDetails(null);
                setError(result.error || 'Invalid IFSC Code');
            }

            return result;
        } catch (err) {
            setError('Failed to validate IFSC code');
            setBankDetails(null);
            return { isValid: false, error: err.message };
        } finally {
            setLoading(false);
        }
    }, [provider]);

    const clearValidation = useCallback(() => {
        setBankDetails(null);
        setError(null);
        setLoading(false);
    }, []);

    return {
        validateIFSC,
        clearValidation,
        loading,
        bankDetails,
        error,
        isValid: !!bankDetails
    };
};
const validateIFSCRazorpay = async (ifscCode) => {
    try {
        const response = await fetch(`https://ifsc.razorpay.com/${ifscCode}`);
        if (response.ok) {
            const data = await response.json();
            return {
                isValid: true,
                bankDetails: {
                    bank: data.BANK,
                    branch: data.BRANCH,
                    city: data.CITY,
                    district: data.DISTRICT,
                    state: data.STATE,
                    address: data.ADDRESS,
                    contact: data.CONTACT,
                    imps: data.IMPS,
                    rtgs: data.RTGS,
                    neft: data.NEFT,
                    upi: data.UPI
                }
            };
        } else {
            return { isValid: false, error: 'Invalid IFSC Code' };
        }
    } catch (error) {
        return { isValid: false, error: 'Network error or invalid IFSC' };
    }
};